module.exports = __webpack_public_path__ + "img/icon.1577db07.svg";